import React from 'react';
import PropTypes from 'prop-types';

const PageHeader = (props) => {
  let error;
  // mock error messages
  if (props.heading === 'Settings') {
    error = '- user is not authenticated!'
  } else if (props.heading === 'Markets') {
    error = '- available markets is outdated!'
  } else if (props.heading === 'Page Not Found') {
    error = '- this page cannot be found'
  } else {
    error = '- this page has an error!'
  }
  console.error(props.heading, error)
  return (
    <div style={props.backgroundImage} className="intro-header">
      <div className="site-heading">
        <h1>{props.heading}</h1>
        <hr className="small" />
        <span className="subheading">{props.subheading}</span>
      </div>
    </div>
  )
}

PageHeader.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  backgroundImage: PropTypes.shape({
    backgroundImage: PropTypes.string
  }),
}

export default PageHeader


// WEBPACK FOOTER //
// ./src/components/pages/components/PageHeader.js